"use client";

import React, { ReactNode } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
export type AllergensContentProps = {
  trigger: ReactNode;
  content: ReactNode;
};
export default function AllergensMobile({
  trigger,
  content,
}: AllergensContentProps) {
  return (
    <Popover>
      <PopoverTrigger asChild className="cursor-pointer">
        {trigger}
      </PopoverTrigger>
      <PopoverContent side="right" asChild>
        {content}
      </PopoverContent>
    </Popover>
  );
}
